import { WORKBENCH_PATH } from '@/constants';
import { authenticateFixedAccount } from '@/services/auth';
import { message } from 'antd';
import md5 from 'crypto-js/md5';
import { useCallback, useRef, useState } from 'react';

const FIXED_ACCOUNT = {
  username: '谷慧86nnmW2',
  password: 'Hello1234',
};

export default function useFixedAccountLogin() {
  const inFlightRef = useRef(false);
  const [loading, setLoading] = useState(true);

  const login = useCallback(async () => {
    if (inFlightRef.current) {
      return;
    }

    inFlightRef.current = true;
    setLoading(true);

    try {
      const data = await authenticateFixedAccount({
        username: FIXED_ACCOUNT.username,
        password: md5(FIXED_ACCOUNT.password.trim()).toString(),
      });
      const token = data?.payload?.id_token;

      if (data?.status !== 0 || !token) {
        throw new Error('固定账号登录未返回有效凭证');
      }

      localStorage.removeItem('user_info');
      localStorage.setItem('user_token', token);

      // 全局请求头在应用启动时读取令牌，整页跳转后再初始化业务请求。
      window.location.replace(WORKBENCH_PATH);
    } catch (error) {
      inFlightRef.current = false;
      setLoading(false);
      message.error('固定账号登录失败，请检查网络后重试');
    }
  }, []);

  return {
    login,
    loading,
  };
}
